import { interpolatePath } from './operators/interpolatePath';
import { parse } from './parse';
export function interpolate(paths, options) {
    return interpolatePath(paths.map(parse), options || {});
}
